import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ConversionLandingPage from "./components/ConversionLandingPage";
import BookServicePage from "./components/BookServicePage";
import SeoCityPage from "./components/SeoCityPage";
import SeoBrandPage from "./components/SeoBrandPage";
import SeoProblemPage from "./components/SeoProblemPage";
import SeoB2BPage from "./components/SeoB2BPage";
import { ScrollToTop } from "./components/ScrollToTop";
import TechnicianApplicationPage from "./components/TechnicianApplicationPage";
import { SiteSeo } from "./components/SiteSeo";
import NotFoundPage from "./components/NotFoundPage";
import AdminPage from "./components/admin/AdminPage";

export function AppRoutes() {
  return (
    <div className="App">
        <SiteSeo />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<ConversionLandingPage />} />
          <Route path="/3d-printer-repair-melbourne" element={<SeoCityPage cityKey="melbourne" />} />
          <Route path="/3d-printer-repair-sydney" element={<SeoCityPage cityKey="sydney" />} />
          <Route path="/3d-printer-repair-brisbane" element={<SeoCityPage cityKey="brisbane" />} />
          <Route path="/3d-printer-repair-perth" element={<SeoCityPage cityKey="perth" />} />
          <Route path="/3d-printer-repair-adelaide" element={<SeoCityPage cityKey="adelaide" />} />
          <Route path="/bambu-lab-repair-australia" element={<SeoBrandPage brandKey="bambuLab" />} />
          <Route path="/3d-printer-blob-of-death-repair" element={<SeoProblemPage problemKey="blobOfDeath" />} />
          <Route path="/3d-printer-nozzle-clog-repair" element={<SeoProblemPage problemKey="nozzleClog" />} />
          <Route path="/3d-printer-layer-shifting-repair" element={<SeoProblemPage problemKey="layerShifting" />} />
          <Route path="/3d-printer-bed-adhesion-repair" element={<SeoProblemPage problemKey="bedAdhesion" />} />
          <Route path="/3d-printer-under-extrusion-repair" element={<SeoProblemPage problemKey="underExtrusion" />} />
          <Route path="/3d-printer-repairs-for-schools" element={<SeoB2BPage pageKey="schoolRepairs" />} />
          <Route path="/3d-printer-maintenance-for-schools" element={<SeoB2BPage pageKey="schoolMaintenance" />} />
          <Route path="/apply-as-technician" element={<TechnicianApplicationPage />} />
          <Route path="/book-service" element={<BookServicePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
    </div>
  );
}

function App() {
  return <BrowserRouter><AppRoutes /></BrowserRouter>;
}

export default App;